import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/by.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/cn.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/kz.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/ru.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/tj.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/preview/other-countries/usd-background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/_components/call-to-action/_components/call-to-action-observer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/call-to-action/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/custom-header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevelopmentWithWbObserver"] */ "/app/src/_components/development-with-wb/_components/development-with-wb-observer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/_components/development-with-wb/_components/link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/development-with-wb/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/education-observer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/education-program/_components/all-materials-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/education-program/_components/link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/education-program/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/pro-wb-link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/how-to-start/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/login-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewWithImage"] */ "/app/src/_components/preview-with-image/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/temp-nav-buttons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobeIcon"] */ "/app/src/_kit/icons/globe-icon/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_kit/text/index.module.scss");
